import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getBomForProductTesting = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_BOM_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getcompletionDetails = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.SET_PERMISSION}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postPermissions = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_COSTING.POST_PERMISSION}/${id}/product-costing`, null, { params: { ...data } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addProductCostingDataService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_COSTING.ADD_PRODUCT_COSTING}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductCostingListService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.GET_PRODUCT_COSTING_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCostingStatsService = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.COSTING_STATS}`, {
      params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteProductCostingService = async (deleteId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PRODUCT_COSTING.DELETE_PRODUCT_COSTING}`, {
      data: deleteId,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getProductCostingDetailByIdService = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.COMMON_API_PATH}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Saves a costing.
 *
 * `supplierId` is sent alongside `productId` so the route's ownership gate can
 * authorise the credential-less non-integrated supplier link, which has no
 * session. `modifiedBy` carries that supplier id and is set only on that link.
 * Sessioned callers are authorised by their session and are unaffected.
 */
export const updateProductCostingDataService = async (data) => {
  try {
    return await apiClient.put(
      `${apiEndpoint}${API.PRODUCT_COSTING.UPDATE_PRODUCT_COSTING}`,
      {
        data: { ...data },
      },
      {
        params: { productId: data._id, ...(data.modifiedBy ? { supplierId: data.modifiedBy } : {}) },
      },
    );
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const copyProductCostingDocService = async (id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_COSTING.COPY_PRODUCT_COSTING}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const inviteSupplierService = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_COSTING.INVITE_SUPPLIER}/${data._id}`, {
      data: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const clearAllProductCostingSuggestedHighlightsService = async (id, keys) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_COSTING.CLEAR_ALL}/${id}`, {
      data: { ...keys },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addCommentService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_COSTING.ADD_COMMENT}`, {
      data: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductCostingCommentsService = async (costingId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.GET_PRODUCT_COSTING_COMMENT_LIST}/${costingId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateProductCostingCommentService = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_COSTING.UPDATE_COSTING_COMMENT}/${data._id}`, {
      data: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductColourwaysService = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_PRODUCT_COLOURS}`, {
      params: { devOrderId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductLengthsService = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_PRODUCT_LENGTHS}`, {
      params: { devOrderId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchProductSizesService = async (devOrderId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_PRODUCT_SIZES}`, {
      params: { devOrderId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUnIntegratedSupplierCostingDetailsById = async (obj) => {
  const copyObj = { ...obj };
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_UNINTERGRATED_PRODUCT_COSTING_DETAILS}`, {
      params: { ...copyObj },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUnIntegratedSupplierColouways = async (obj) => {
  const copyObj = { ...obj };
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_UNINTERGRATED_COLOURWAYS}`, {
      params: { ...copyObj },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUnIntegratedSupplierUnits = async (obj) => {
  const copyObj = { ...obj };
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_UNINTERGRATED_UNITS}`, {
      params: { ...copyObj },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchSupplierDetailsService = async (supplierId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.SUPPLIER_DETAILS}/${supplierId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchExchangeRateArrService = async (obj) => {
  const copyObj = { ...obj };
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_EXCHANGE_RATE}`, {
      params: { ...copyObj },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchMultipleExchangeRateService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_EXCHANGE_RATE}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Reads every exchange rate the tenant holds, for callers that recalculate across many season/year
 * pairs at once and filter locally rather than issuing one request per pair.
 * @returns {Promise<object>} the response envelope carrying the full ExchangeRate list
 */
export const fetchAllExchangeRatesService = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_EXCHANGE_RATE}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateCurrencyinSupplierOverviewService = async (obj) => {
  const copyObj = { ...obj };
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_COSTING.SUPPLIER_CURRENCY_UPDATE}`, {
      params: { ...copyObj },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const setDefaultProductService = async (id, devOrderId) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_COSTING.SET_DEFAULT}/${devOrderId}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomForMultipleProducts = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_BOM_LIST}`, { ...data });
  } catch (error) {
    console.log('error', error);
    throw error;
  }
};

export const multiProductCostingAdd = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.MULTI_PRODUCT_COSTING_ADD}`, { ...data });
  } catch (error) {
    console.log('error', error);
    throw error;
  }
};

export const getUnIntegratedSupplierCostingStage = async (obj) => {
  const copyObj = { ...obj };
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_UNINTERGRATED_COSTING_STAGE}`, {
      params: { ...copyObj },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Sample Ref dropdown options for one costing, scoped to the costing's own product.
 * Shares the guards of the costing-stage endpoint it replaces, so it also serves the
 * non-integrated supplier link, which carries no session.
 * @param {Object} obj query params, carrying productId (the costing id) and supplierId
 * @returns {Promise<Object>} the API response whose data is an array of { _id, sampleNumber }
 */
export const getProductCostingSampleRefs = async (obj) => {
  const copyObj = { ...obj };
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_COSTING.FETCH_SAMPLE_REFS}`, {
      params: { ...copyObj },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveMultiCostingComment = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_COSTING.ADD_MULTI_COMMENT}`, {
      data: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
